export const RequestOrigin = {
    Unknown: 'Unknown',
    Mobile: 'Mobile',
    Desktop: 'Desktop',
    BackgroundJob: 'BackgroundJob',
    Webhook: 'Webhook',
    Redirect: 'Redirect',
    CustomerPortal: 'CustomerPortal',
    CustomerPortal2: 'CustomerPortal2',
    FMA: 'FMA',
    CPB: 'CPB',
    PrequalificationLink: 'PrequalificationLink',
    AIEstimates: 'AIEstimates',
    AIJobBriefing: 'AIJobBriefing',
} as const;

export type RequestOrigin = (typeof RequestOrigin)[keyof typeof RequestOrigin];

export const SourceMfe = {
    AsLowAs2: 'as-low-as-2',
    HomeownerApplication: 'homeowner-application',
    TechnicianApplication: 'technician-application',
    TechnicianPostApplication: 'technician-post-application',
    PrequalsBanner: 'prequals-banner',
    PrequalsLanding: 'prequals-landing',
    PrequalsSettings: 'prequals-settings',
    ApplicationManagement: 'application-management',
    Accounts: 'accounts',
    Providers: 'providers',
    Settings: 'settings',
    Rules: 'rules',
    Unknown: 'Unknown',
} as const;

export type SourceMfe = (typeof SourceMfe)[keyof typeof SourceMfe] | (string & {});

export type EntryPoint = string;

export interface RequestAttributionProps {
    origin?: RequestOrigin;
    entryPoint?: EntryPoint;
    sourceMfe?: SourceMfe;
}
